<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item" v-if="false">
                    <a class="nav-link" href="#" :class="aba == 'visao' ? 'active' : ''" @click.prevent="abrir('visao')">
                        Visão Geral
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'coleta' ? 'active' : ''" @click.prevent="abrir('coleta')">
                        Coleta
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'rastreabilidade-amostra' ? 'active' : ''" @click.prevent="abrir('rastreabilidade-amostra')">
                        Rastreabilidade de Amostra
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'amostras' ? 'active' : ''" @click.prevent="abrir('amostras')">
                        Amostras
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'resultados-lote' ? 'active' : ''" @click.prevent="abrir('resultados-lote')">
                        Resultados
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'informacoes' ? 'active' : ''" @click.prevent="abrir('informacoes')">
                        Informações
                    </a>
                </li>
                <li class="nav-item" v-if="false">
                    <a class="nav-link" href="#" :class="aba == 'curva' ? 'active' : ''" @click.prevent="abrir('curva')">
                        Curva
                    </a>
                </li>
                <li class="nav-item" v-if="false">
                    <a class="nav-link" href="#" :class="aba == 'entrega' ? 'active' : ''" @click.prevent="abrir('entrega')">
                        Entrega de Material
                    </a>
                </li>

                <li class="nav-item" v-if="false">
                    <div class="btn-group dropleft">
                        <button class="btn btn-light dropdown-toggle" type="button" id="triggerId" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                            <i class="fas fa-ellipsis-h ml-2"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="triggerId">
                            <a class="dropdown-item" href="#" :class="aba == 'tipos' ? 'active' : ''" @click.prevent="abrir('tipos')">
                                Tipos
                            </a>
                            <a class="dropdown-item" href="#" :class="aba == 'abrir' ? 'active' : ''" @click.prevent="abrir('abrir')">
                                Abrir
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <laboratorio-visao-geral v-if="aba == 'visao'" />
        <coleta-material v-if="aba == 'coleta'" />
        <resultado-lote v-if="aba == 'resultados-lote'" />
        <rastreabilidade-amostra v-if="aba == 'rastreabilidade-amostra'" />
        <posicao-amostras v-if="aba == 'amostras'" />
        <informacoes v-if="aba == 'informacoes'" />

    </div>
</template>

<script>
import ColetaMaterial from './ColetaMaterial.vue';
import LaboratorioVisaoGeral from './LaboratorioVisaoGeral.vue';
import ResultadoLote from './ResultadoLote.vue';
import RastreabilidadeAmostra from './RastreabilidadeAmostra.vue';
import PosicaoAmostras from './PosicaoAmostras.vue';
import Informacoes from '../callcenter/Informacoes.vue';

export default {
    data() {
        return {
            dados: null,
            parms: null,
        };
    },

    props: ['aba'],

    components: {
        ColetaMaterial,
        LaboratorioVisaoGeral,
        ResultadoLote,
        RastreabilidadeAmostra,
        PosicaoAmostras,
        Informacoes,  
    },

    methods: {
        abrir(aba) {
            if ( aba != this.aba ) {
                this.$router.push({ path: '/laboratorio/' + aba });
            }
        },
    }
}
</script>
